export function ConfirmDeleteModal({ isOpen, onConfirm, onCancel }) {
  if (!isOpen) return null;
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
      background: 'rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
    }}>
      <div style={{ background: 'white', padding: 32, borderRadius: 8, minWidth: 320, boxShadow: '0 2px 16px #333' }}>
        <h2 style={{marginBottom: 16}}>Confirm Delete</h2>
        <p>Are you sure you want to delete this row?</p>
        <div style={{display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 24}}>
          <button className='redButton' onClick={onConfirm}>Delete</button>
          <button className='blueButton' onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
